import React from 'react'
import Translation from '../global/Translation'

import { injectIntl } from 'react-intl'

import logo from '../../assets/img/e.cosentino.svg'

import AlertsContainer from '../alerts/AlertsContainer'
import Spinner from '../global/Spinner'

class ForgotPasswordForm extends React.Component {
    constructor(props) {
        super(props)

        this.state = { forgotPassword: null }
    }

    handleSubmit = e => {
        e.preventDefault()
        this.props.onRecoverPassword(this.usernameInput.value, this.emailInput.value)
    }

    render() {
        const { isLogging } = this.props

        const spinner = isLogging ? <Spinner isLoading={isLogging} /> : null

        return (
            <div className="form-signin">
                <form onSubmit={this.handleSubmit}>
                    <AlertsContainer />
                    {spinner}
                    <img alt="" id="profile-img" className="d-block d-lg-none profile-img-card" src={logo} style={{ marginBottom: '30px' }} />
                    <label htmlFor="email">
                        <Translation id="identifier" defaultMessage="Identifier" />
                    </label>
                    <input
                        type="text"
                        id="inputEmail"
                        className="form-control"
                        placeholder={this.props.intl.formatMessage({ id: 'identifier' })}
                        autoFocus
                        ref={node => {
                            this.usernameInput = node
                        }}
                    />
                    <label htmlFor="email">
                        <Translation id="email" defaultMessage="Email" />
                    </label>
                    <input
                        type="email"
                        id="inputEmail"
                        className="form-control mb-3"
                        placeholder="Email"
                        ref={node => {
                            this.emailInput = node
                        }}
                        onKeyPress={e => {
                            if (e.key === 'Enter') {
                                this.handleSubmit(e)
                            }
                        }}
                    />
                    <div id="remember" className="checkbox" />
                    <input type="submit" className="bt bt-dark bt-login loginbutton" value={this.props.intl.formatMessage({ id: 'recover_password' })} />

                    <div className="row links">
                        <div className="col-12 col-md-7 offset-md-5 forgot-password">
                            <span onClick={this.props.showLogin}>
                                <Translation id="login" defaultMessage="Login" />
                            </span>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

export default injectIntl(ForgotPasswordForm)
